var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ingresante-a-b-m-cursado',{attrs:{"headers":_vm.headers},scopedSlots:_vm._u([{key:"item.cursados",fn:function(ref){
var item = ref.item;
return _vm._l((item.cursados),function(cursado){return _c('div',{key:cursado.id},[_vm._v(" "+_vm._s(cursado.nombre)+" ")])})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }